import { Ref, computed, ComputedRef } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  CreativeConfig,
  defaultImageLoadFailedPicture,
  IMAGE_X_IMG_TEMPLATE,
  PlatformType,
} from '@tt4b/ttam-enums';
import { getImgSrcByImageX } from '@tt4b/ttam-utils';
import AppleIcon from '@tt4b/ttam-assets/src/svgs/apple.svg?url';
import AndroidIcon from '@tt4b/ttam-assets/src/svgs/android.svg?url';
import { AppDataItem } from '../types';
import { useAppList } from './useAppList';

export function useAppEvents(opt: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  creativeConfig: Ref<CreativeConfig>;
  isRetargetingApp: Ref<boolean>;
}) {
  const { creativeConfig, isRetargetingApp } = opt;

  const isAppSelectDisabled = computed(() => creativeConfig.value.disableAll);

  const { loading, oriAppList, loadAppList: handleLoadAppList } = useAppList();

  const data: ComputedRef<AppDataItem[]> = computed(() =>
    oriAppList.value.map(i => ({
      ...i,
      name: i.AppName || '- -',
      icon: i.Platform === PlatformType.IOS ? AppleIcon : AndroidIcon,
      img: getImgSrcByImageX(i.Icon.web_uri, IMAGE_X_IMG_TEMPLATE.COMPRESS_IMAGE, '') || defaultImageLoadFailedPicture,
      desc: `ID：${i.AppId}`,
    }))
  );

  const isEmpty = computed(() => data.value.length === 0);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const loadAppList = () => handleLoadAppList({ is_retargeting: isRetargetingApp.value || false });

  return {
    dataSource: data,
    oriAppList,
    isEmpty,
    loading,
    loadAppList,
    isAppSelectDisabled,
  };
}
